import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  container: {
    paddingLeft: '5px',
    paddingRight: '5px',
    justifyContent: 'flex-start',
  },
});
